import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router-dom'
import BadgesV1Index from 'views/admin/BadgesV1'
import ConfigurationListing from 'views/admin/BadgesV1/Configurations/ConfigurationListing'
import ConfigurationPage from 'views/admin/BadgesV1/Configurations/ConfigurationPage'

const BadgesV1 = () => {
  const { path } = useRouteMatch()
  return (
    <Switch>
      <Route exact path={path}>
        <BadgesV1Index />
      </Route>
      <Route exact path={`${path}/configuration`}>
        <ConfigurationListing />
      </Route>
      <Route exact path={`${path}/configuration/add`}>
        <ConfigurationPage />
      </Route>
      <Route exact path={`${path}/configuration/edit/:configurationId`}>
        <ConfigurationPage />
      </Route>
    </Switch>
  )
}

export default BadgesV1
